import React from 'react';
import PropTypes from 'prop-types';
import './GenericConfirmActionModal.scss';

const GenericConfirmActionModal = ({
  title,
  message,
  onCancel,
  onConfirm,
  confirmLabel = 'Confirm',
  actionType = 'default' // 'leave', 'delete', 'default'
}) => {
  const getActionButtonClass = () => {
    switch (actionType) {
      case 'leave':
        return 'confirm-button-blue';
      case 'delete-group':
        return 'confirm-button-red';
      default:
        return 'confirm-button-blue';
    }
  };

  return (
    <div className="confirm-modal-overlay">
      <div className="confirm-modal">
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="confirm-button-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className={getActionButtonClass()} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

GenericConfirmActionModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string,
  actionType: PropTypes.oneOf(['leave', 'delete-group', 'default']),
};

export default GenericConfirmActionModal;
